import { TimezoneRegionsEnum } from "Market/Enums/timezoneRegionEnum";
import moment from "moment-timezone";
import { useMemo } from "react";

export const useTimezones = () => {
	const timezoneOptions = useMemo(() => {
		return moment.tz
			.names()
			.filter((tz) => {
				const [region] = tz.split("/");
				return Object.values(TimezoneRegionsEnum).includes(
					region as TimezoneRegionsEnum,
				);
			})
			.map((tz) => ({
				label: tz,
				value: tz,
			}));
	}, []);

	return timezoneOptions;
};
